/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Edits a specific allocation rule
 */
export const activeAllocationRuleUpdateParams = zod.object({
  "allocationRuleId": zod.string(),"fundFamilyId": zod.string()
})

export const activeAllocationRuleUpdateBody = zod.object({
  "transaction_calculation_id": zod.string().min(1),"allocation_rule_name": zod.string().min(1),"date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"change_reason_notes": zod.string().min(1)
})

export const activeAllocationRuleUpdateResponseAnnotationsSetMin = 2;
export const activeAllocationRuleUpdateResponseAnnotationsSetMax = 2;

export const activeAllocationRuleUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(activeAllocationRuleUpdateResponseAnnotationsSetMin).max(activeAllocationRuleUpdateResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"fund_family_id": zod.string().min(1),"entity_id": zod.string().min(1),"effective_start_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"version": zod.number().optional(),"transaction_calculation_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"state": zod.enum(['archived', 'active', 'draft', ""]).optional(),"is_static": zod.boolean().optional(),"start_reason_notes": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"allocation_rule_graph_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1),"rule_id": zod.string().min(1),"start_reason_fund_family_event_id": zod.string().min(1),"end_reason_fund_family_event_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"end_reason_notes": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"effective_end_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"entity_name": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional()
})

